import { render, staticRenderFns } from "./Cardaddcomment.vue?vue&type=template&id=870100d2&"
import script from "./Cardaddcomment.vue?vue&type=script&lang=js&"
export * from "./Cardaddcomment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports